import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoginService } from "../../login/login.service";
import { LoadingService } from "../loading-spinner/loading.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    private _totalRequests = 0;

    constructor(
        private _loginService: LoginService,
        private _loadingService: LoadingService,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const publicEndpoints = ["htlAccount/login", "public/htl-viewer"];
        const isPublic = publicEndpoints.some((url) => request.url.includes(url));

        const isChatbot = request.url.startsWith(environment.aiApiUrl);

        if (!isChatbot) {
            this._totalRequests++;
            this._loadingService.setHttpProgressStatus(true);
        }

        if (!isPublic) {
            const currentUser = this._loginService.currentUserDataValue;
            if (currentUser && currentUser.sessionToken) {
                request = request.clone({
                    setHeaders: {
                        "X-Access-Token": currentUser.sessionToken,
                    },
                });
            }
        }

        return next.handle(request).pipe(
            finalize(() => {
                if (isChatbot) return;

                this._totalRequests--;
                if (this._totalRequests === 0) {
                    // setTimeout(() => {
                    this._loadingService.setHttpProgressStatus(false);
                    // }, 1000);
                }
            }),
        );
    }
}
